import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
  LabelList,
  Cell,
  Text,
} from "recharts";
import { Grid, Paper, Box, Typography } from "@mui/material";
import { getExpertQCountsInOverview } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { Spin } from "antd";
import VizHeader from "../VizHeader/VizHeader";
import { Tooltip as Tooltip2 } from "@mui/material";

export default function RatingsReceivedByExpertOverview() {
  const expertOverview = useSelector((state) => state.expertOverviewCmReducer);
  const dispatch = useDispatch();
  const { getExpertsQCountsDataInOverview } = bindActionCreators(
    Actions,
    dispatch
  );
  const cmRootReducer = useSelector((state) => state.cmRoot);
  const [loading, setLoading] = React.useState(false);
  const [activeKeys, setActiveKeys] = React.useState([
    "1 Star",
    "2 Star",
    "3 Star",
    "4 Star",
    "5 Star",
    "Not Rated",
  ]);
  const [opacity, setOpacity] = React.useState({
    [`1 star`]: 1,
    [`2 star`]: 1,
    [`3 star`]: 1,
    [`4 star`]: 1,
    [`5 star`]: 1,
    [`Not Rated`]: 1,
  });
  const [activeLegend, setActiveLegend] = React.useState(null);
  const [getTooltipPayload, setTooltipPayload] = React.useState([]);

  useEffect(() => {
    setLoading(true);
    getExpertQCountsInOverview(cmRootReducer.selectedDomainIds).then((res) => {
      if (res === undefined) return;
      if (res.data.data !== undefined || res.data.success) {
        setLoading(false);
        getExpertsQCountsDataInOverview(res.data.data);
        // console.log(expertOverview.getExpertQCounts)
      }
    });
  }, [cmRootReducer.selectedDomainIds]);

  const handleLegendClick = (e) => {
    const { dataKey } = e;
    // console.log(dataKey, 'check datakey')
    const isActive = activeKeys.includes(dataKey);

    // If active, remove it from activeKeys; if not active, add it
    setActiveKeys((prevActiveKeys) =>
      isActive
        ? prevActiveKeys.filter((key) => key !== dataKey)
        : [...prevActiveKeys, dataKey]
    );
    // setLegendClicked(!legendClicked)
    // setLegendName(name)
  };

  const handleMouseEnter = useCallback((o) => {
    const { dataKey } = o;
    // console.log(dataKey,'check data key')
    // setOpacity((prevOpacity) => ({
    //   ...prevOpacity,
    //   [dataKey]: 0.2,
    // }));
    setActiveLegend(dataKey);
  }, []);

  const handleBarMouseEnter = (data) => {
    setTooltipPayload(data?.tooltipPayload);
  };

  const handleBarMouseLeave = () => {
    setTooltipPayload([]);
  };

  const handleMouseLeave = useCallback((o) => {
    const { dataKey } = o;
    // setOpacity((prevOpacity) => ({
    //   ...prevOpacity,
    //   [dataKey]: 1,
    // }));
    setActiveLegend(null);
  }, []);

  const CustomizedTooltip = ({ active, label, payload }) => {
    if (
      active &&
      payload &&
      payload.length > 0 &&
      getTooltipPayload.length > 0
    ) {
      // let totalCount = payload.filter((obj)=>{
      //   if(obj.value > 0)
      //   {
      //     return obj.payload['Total Ratings']
      //   }
      // })
      return (
        <>
          <p
            className="custom-tooltip"
            style={{
              backgroundColor: "#fff",
              border: `1px solid ${getTooltipPayload[0]?.color}`,
              padding: "7px",
            }}
          >
            {/* <p className="label" style={{marginLeft:'5px',marginBottom:'3px'}}>{payload[0]?.payload.name}</p>
            <p className="label" style={{marginLeft:'5px'}}>Total Ratings:{" "}{payload[0]?.payload['Total Ratings']}</p>
            {
              payload?.map((obj, ind) => {
                if (obj.value > 0) {
                  return (
                    <>
                      <p className="label" style={{color:obj.color,margin:'5px',textTransform:'capitalize'}}>{obj.dataKey}:{" "}{obj.value}</p>
                    </>
                  )
                }
              })
            } */}
            {getTooltipPayload?.map((obj, ind) => {
              if (obj?.value > 0) {
                return (
                  <>
                    <p className="label">{obj?.payload?.name}</p>
                    <p className="label">
                      Total Ratings: {obj?.payload?.["Total Ratings"]}
                    </p>
                    <p
                      className="label"
                      style={{ color: obj?.color, fontWeight: "bold" }}
                    >
                      {obj?.name}: {obj?.value}
                    </p>
                  </>
                );
              }
            })}
          </p>
        </>
      );
    }
  };

  const tickFormatter = (value) => {
    const limit = 10;
    if (value.length <= limit) return value;
    else {
      return `${value.substring(0, limit)}...`;
    }
  };

  const truncate = (str, max = 8) => {
    if (!str) return "";
    return str.length > max ? str.substring(0, max) + "…" : str;
  };
  const CustomTick = ({ x, y, payload }) => {
    const fullName = payload?.value || "";
    const parts = fullName.split(" ");
    const first = parts[0] || "";
    const last = parts.slice(1).join(" "); // supports middle names too

    // value shown in the axis (first line + second line)
    const displayValue = last ? `${first}\n${last}` : first;
    console.log(displayValue);
    return (
      <Tooltip2 title={fullName} placement="top">
        <g transform={`translate(${x},${y})`}>
          <Text
            x={0}
            y={0}
            textAnchor="end"
            verticalAnchor="start"
            angle={-35} // slanted
            fontSize={11}
          >
            {truncate(fullName, 16)}
          </Text>
        </g>
      </Tooltip2>
    );
  };
  return (
    <div style={{ paddingRight: "15px" }}>
      <Spin spinning={loading}>
        <Grid container paddingTop={1} xs={12} xl={12} md={12} sm={12}>
          <Grid item xs={12}>
            <Paper>
              <Box sx={{ width: "100%", paddingBottom: "7px" }}>
                <div style={{ textAlign: "center", paddingTop: "10px" }}>
                  <VizHeader type={4} isBold={true}>
                    Ratings Received by Experts - Top 30
                  </VizHeader>
                </div>
                <ResponsiveContainer width={"100%"} height={400}>
                  <BarChart
                    // width={1300}
                    // height={450}
                    data={expertOverview.getExpertQCounts}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 40,
                    }}
                    barSize={40}
                  >
                    <defs>
                      <linearGradient id="colorUv" x1="1" y1="1" x2="0" y2="0">
                        <stop
                          offset="32%"
                          stopColor="#fff476"
                          stopOpacity={0.5}
                        />
                        <stop
                          offset="94%"
                          stopColor="#FFFFFF"
                          stopOpacity={0.5}
                        />
                      </linearGradient>
                    </defs>
                    <CartesianGrid
                      stroke="#ececec"
                      vertical={false}
                      // fill="url(#colorUv)"
                    />
                    <XAxis
                      dataKey="name"
                      angle={-45}
                      tick={<CustomTick />}
                      fontSize={12}
                      interval={0}
                      tickFormatter={(value) => tickFormatter(value)}
                      height={40}
                    >
                      <Label
                        value="Experts"
                        offset={0}
                        position="bottom"
                        fontSize={14}
                        fontWeight="bold"
                        dy={32}
                      />
                    </XAxis>
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      fontSize={12}
                      allowDecimals={false}
                      label={{
                        fontSize: "14px",
                        value: "Number of Ratings",
                        angle: -90,
                        position: "insideCenter",
                        fontWeight: "bold",
                        dx: -22,
                      }}
                    />
                    <Tooltip
                      wrapperStyle={{ fontSize: "12px", fontWeight: "bold" }}
                      cursor={{ fill: "transparent" }}
                      content={<CustomizedTooltip />}
                    />
                    <Legend
                      wrapperStyle={{
                        fontSize: "12px",
                        bottom: -5,
                        paddingTop: "7px",
                        margin: "7px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={handleLegendClick}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    />
                    <Bar
                      isAnimationActive={true}
                      animationEasing="ease"
                      dataKey="1 Star"
                      stackId="a"
                      fill="#009bff"
                      hide={!activeKeys.includes("1 Star")}
                      // fillOpacity={opacity["1 star"]}
                      opacity={
                        activeLegend === "1 Star" || activeLegend === null
                          ? 1
                          : 0.2
                      }
                      onMouseEnter={handleBarMouseEnter}
                      onMouseLeave={handleBarMouseLeave}
                    />
                    <Bar
                      isAnimationActive={true}
                      animationEasing="ease"
                      dataKey="2 Star"
                      stackId="a"
                      fill="#00b8e6"
                      hide={!activeKeys.includes("2 Star")}
                      // opacity={opacity["2 star"]}
                      opacity={
                        activeLegend === "2 Star" || activeLegend === null
                          ? 1
                          : 0.2
                      }
                      onMouseEnter={handleBarMouseEnter}
                      onMouseLeave={handleBarMouseLeave}
                    />
                    <Bar
                      isAnimationActive={true}
                      animationEasing="ease"
                      dataKey="3 Star"
                      stackId="a"
                      fill="#b85cff"
                      hide={!activeKeys.includes("3 Star")}
                      // opacity={opacity["3 star"]}
                      opacity={
                        activeLegend === "3 Star" || activeLegend === null
                          ? 1
                          : 0.2
                      }
                      onMouseEnter={handleBarMouseEnter}
                      onMouseLeave={handleBarMouseLeave}
                    />
                    <Bar
                      isAnimationActive={true}
                      animationEasing="ease"
                      dataKey="4 Star"
                      stackId="a"
                      fill="#5e3bff"
                      hide={!activeKeys.includes("4 Star")}
                      // opacity={opacity["4 star"]}
                      opacity={
                        activeLegend === "4 Star" || activeLegend === null
                          ? 1
                          : 0.2
                      }
                      onMouseEnter={handleBarMouseEnter}
                      onMouseLeave={handleBarMouseLeave}
                    />
                    <Bar
                      isAnimationActive={true}
                      animationEasing="ease"
                      dataKey="5 Star"
                      stackId="a"
                      fill="#f4c900"
                      hide={!activeKeys.includes("5 Star")}
                      // opacity={opacity["5 star"]}
                      opacity={
                        activeLegend === "5 Star" || activeLegend === null
                          ? 1
                          : 0.2
                      }
                      onMouseEnter={handleBarMouseEnter}
                      onMouseLeave={handleBarMouseLeave}
                    />
                    <Bar
                      isAnimationActive={true}
                      animationEasing="ease"
                      dataKey="Not Rated"
                      stackId="a"
                      fill="#ef7928"
                      hide={!activeKeys.includes("Not Rated")}
                      // opacity={opacity["Not Rated"]}
                      opacity={
                        activeLegend === "Not Rated" || activeLegend === null
                          ? 1
                          : 0.2
                      }
                      onMouseEnter={handleBarMouseEnter}
                      onMouseLeave={handleBarMouseLeave}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Spin>
    </div>
  );
}
